import { Module } from 'cerebral'
import Mousetrap from 'mousetrap'

export default function(options) {
  return Module(({ name, path, controller }) => {
    controller.on('initialized', () => {
      options.forEach(option => {
        Mousetrap.bind(
          option.commands,
          e => {
            e.preventDefault()
            e.stopPropagation()
            controller.getSignal(option.trigger)({ keyCode: e.keyCode })
          },
          option.event ? option.event : 'keydown'
        )
      })
    })

    return {}
  })
}



// WEBPACK FOOTER //
// ./src/modules/Shortcuts/shortcuts.js